import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import App from "./App.jsx";
import "./index.css";
import { AuthProvider } from "./auth/AuthContext.jsx";
import { initI18n } from "./i18n/index.js";

// Workstream B Step 3 complete: RouteGuard is wired inside App.jsx's <Routes>,
// wrapping the protected "/" route. BrowserRouter stays at top level here.
// RouteGuard is NOT placed here — per DD-03, it wraps the protected route only.

// M041 Phase 1: i18n initialised at boot with English base strings (login screen).
// M041 Phase 2: post-login tenant locale + overrides are injected in AuthContext.jsx
// via applyTenantOverrides() after successful login — before authenticated shell renders.
initI18n().then(() => {
  ReactDOM.createRoot(document.getElementById("root")).render(
    <React.StrictMode>
      <BrowserRouter>
        <AuthProvider>
          <App />
        </AuthProvider>
      </BrowserRouter>
    </React.StrictMode>
  );
});
